export default __webpack_public_path__ + "static/media/home-illustration.df1b7ebc.svg";